import type { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'

export type ApprovalStatus = 'approved' | 'pending'

export type ConfigurationItemVisibility =
  | 'enum'
  | 'parameter'
  | 'template'
  | 'library'
  | 'tenant'
  | 'glMap'
  | 'reconciliationSpec'
  | 'hideTemplate'
  | 'hideGlMap'

export type BlockFilterMode = 'all' | 'single' | 'withBaseBlocks'

export type BlockFilter = {
  mode: BlockFilterMode
  selectedBlock: Optional<string>
}

export type FilterStatus = {
  visibleItems: Record<ConfigurationItemVisibility, boolean>
  approvalStatus: Record<ApprovalStatus, boolean>
  blockFilter: BlockFilter
  layerFilter?: Optional<LayerKey>
  showEmptyLayers: boolean
}

export const initialFilterStatus: FilterStatus = {
  visibleItems: {
    parameter: true,
    enum: true,
    template: true,
    library: true,
    tenant: true,
    glMap: true,
    reconciliationSpec: true,
    hideTemplate: true,
    hideGlMap: true,
  },
  approvalStatus: {
    approved: true,
    pending: true,
  },
  blockFilter: {
    mode: 'all',
    selectedBlock: null,
  },
  layerFilter: undefined,
  showEmptyLayers: false,
}
